export default __webpack_public_path__ + "static/media/Newsletter 013.04e8d9a5.png";